// extracted by mini-css-extract-plugin
export default {"Row":"_Row--m0J1a","FirstChildFixedHeight":"_FirstChildFixedHeight--QJm8b"};